import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, IconButton, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { customInputUseStyles } from './CustomTextField';

const CustomSelect = ({
  label,
  options,
  id = 'custom-select',
  value,
  onChange,
  error = false,
  errorMessage = '',
  info = '',
  fullWidth = true,
  limitWidth = false,
}) => {
  const classes = customInputUseStyles();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  //   const tooltipRef = useRef(null);

  const handleTooltipToggle = () => {
    setTooltipOpen(!tooltipOpen);
  };

  //   useEffect(() => {
  //     const handleClickOutside = (event) => {
  //       if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
  //         setTooltipOpen(false); // Close tooltip if click is outside
  //       }
  //     };

  //     // Add when the tooltip is open and remove when it is closed
  //     if (info && tooltipOpen) {
  //       document.addEventListener('mousedown', handleClickOutside);
  //     }
  //     return () => {
  //       document.removeEventListener('mousedown', handleClickOutside);
  //     };
  //   }, [tooltipOpen, info]);

  return (
    <FormControl
      variant="outlined"
      error={error}
      className={`${classes.selectFormControl} ${classes.formControl} ${fullWidth ? 'w-100' : ''} ${
        limitWidth ? classes.maxWidth : ''
      }`}
    >
      <InputLabel
        htmlFor={id}
        className={`${classes.staticLabel} ${classes.inputLabel} ${error ? 'Mui-error' : ''}`}
        shrink={false}
      >
        {label}
      </InputLabel>
      {/* {info && (
        <Tooltip title={info} placement="top" open={tooltipOpen} arrow>
          <IconButton ref={tooltipRef} className={classes.infoIcon} onClick={handleTooltipToggle}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      )} */}
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value}
        onChange={onChange}
        displayEmpty
        className={classes.selectEmpty}
        fullWidth={fullWidth}
        renderValue={value ? undefined : () => <span className={classes.placeholder}>{'Please select one'}</span>}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText style={{ marginLeft: '0px' }}>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default CustomSelect;
